declare global {
  interface Window {
    webkit?: {
      messageHandlers: {
        betterment: {
          postMessage: (data: Record<string, string | number>) => void;
        };
      };
    };
    betterment?: {
      postMessage: (data: string) => void;
    };
  }
}

type WebViewSuccessMessage = {
  eventName: string;
  goalId: number;
  accountId: number;
};

export function postWebViewSuccessMessage(message: WebViewSuccessMessage) {
  if (window.webkit) {
    // iOS message handler
    window.webkit.messageHandlers.betterment.postMessage({
      event_name: message.eventName,
      goal_id: message.goalId,
      account_id: message.accountId,
    });
  } else if (window.betterment) {
    // Android message handler
    window.betterment.postMessage(JSON.stringify(message));
  } else {
    throw new Error('postWebViewSuccessMessage was invoked outside of a mobile webview');
  }
}
